import React from 'react';
import { useNavigate } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Collapse from '@mui/material/Collapse';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import LogoutIcon from '@mui/icons-material/Logout';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SwipeableTemporaryDrawer() {
  const navigate = useNavigate();
	//const leadPageUrl = Cookies.get('leadPageUrl');
  const userObj = useSelector(state => state.userDetails);
  const [openSubList, setOpenSubList] = React.useState(false);

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  function handleClickSubList(){    
    setOpenSubList(!openSubList);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  function goToLocation(url){
    navigate('/'+url);
  }
  function logout(){
    Cookies.remove('isrwadminloggedin');
    navigate('/login');
  }


  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"      
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Stack direction="row" spacing={2} style={{margin: 20}} >
        <Avatar onClick={()=>{goToLocation('profile')}} style={{cursor:'pointer'}} alt={userObj.fullName} src="/static/images/avatar/1.jpg" sx={{ width: 29, height: 29, marginRight:1 }} />
        <span onClick={()=>{goToLocation('profile')}} style={{cursor:'pointer', marginTop: 1, fontSize: 14}} >{userObj.fullName}</span>
      </Stack>
      <Divider />
      
      {/* <Link href='dashboard' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Dashboard" />
        </ListItem>
      </Link> */}
      
      <Link href='free-company' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Company (Data Entry)" />
        </ListItem>
      </Link>

      {/* <Link href='leads' style={{color:'#000',textDecoration:'none'}} >      
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Leads" />
        </ListItem>
      </Link> */}
      {/* <Link href='activities' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Activities" />
        </ListItem>
      </Link> */}
      {/* <ListItem button onClick={()=>{goToLocation('technicians')}} >
            <ListItemIcon><DescriptionIcon /></ListItemIcon>
            <ListItemText primary="Technicians" />
      </ListItem> */}
      {/* <ListItem button onClick={()=>{goToLocation('payments')}} >
            <ListItemIcon><DescriptionIcon /></ListItemIcon>
            <ListItemText primary="Payments" />
      </ListItem> */}
      {/* <Link href='invoices' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Invoices" />
        </ListItem>
      </Link> */}
      {/* <Link href='contacts' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Contacts" />
        </ListItem>
      </Link> */}
      {/* <Link href='accounts' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Accounts" />
        </ListItem>
      </Link> */}
      {/* <Link href='campaigns' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Campaigns" />
        </ListItem>
      </Link> */}

      <Link href='keywords' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Keywords" />
        </ListItem>
      </Link>

      {/* <Link href='keywords-treeview' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Keywords Treeview" />
        </ListItem>
      </Link> */}

      {/* <Link href='keywords-tree-list' style={{color:'#000',textDecoration:'none'}} >
        <ListItem>
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="Keywords Tree List" />
        </ListItem>
      </Link> */}

      

      <ListItemButton onClick={()=>{handleClickSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Setup" />
        {openSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>      

        {/* <Link href='account-category' style={{color:'#000',textDecoration:'none'}} >
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Account Category" />
          </ListItemButton>
        </Link>    */}

        {/* <Link href='activity-types' style={{color:'#000',textDecoration:'none'}} >
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Activity Types" />
          </ListItemButton>          
        </Link> */}

          {/* <Link href='lead-channels' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Channels" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-status' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Status" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-types' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Types" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-sources' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Sources" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-tags' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Tags" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-loss-reason' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Loss Reason" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='lead-industry' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Lead Industry" />
            </ListItemButton>
          </Link> */}

          
          {/* <ListItemButton onClick={()=>{goToLocation('payment-sources')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Payment Sources" />
          </ListItemButton> */}

          {/* <ListItemButton onClick={()=>{goToLocation('payment-modes')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Payment Mode" />
          </ListItemButton> */}

          {/* <ListItemButton onClick={()=>{goToLocation('payment-banks')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Payment Banks" />
          </ListItemButton> */}

          {/* <ListItemButton onClick={()=>{goToLocation('brands')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Brands" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('servicecard-types')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Subscription Types" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('city-list')}} sx={{ pl: 4 }}> 
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="City" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('service-category-list')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Service Category" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('service-products')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Service Products" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('case-problem')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Case Problem" />
          </ListItemButton>  */}
          {/* <ListItemButton onClick={()=>{goToLocation('case-reasons')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Case Reasons" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('service-types')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Service Types" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('services')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Services" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('service-package-types')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Service Package Types" />
          </ListItemButton> */}
          {/* <ListItemButton onClick={()=>{goToLocation('service-packages')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Service Packages" />
          </ListItemButton> */}
          {/* {userObj.packageId>1?<>
          <ListItemButton onClick={()=>{goToLocation('sms-templates')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="SMS Template" />
          </ListItemButton>
          <ListItemButton onClick={()=>{goToLocation('sms-api')}} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="SMS API" />
          </ListItemButton>
          </>:null} */}
          {/* <Link href='invoices-types' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Invoice Types" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='invoices-setting' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Invoice Setting" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='setting-master' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Setting Master" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='roles' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Roles" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='visibility' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Visibility" />
            </ListItemButton>
          </Link> */}
          {/* <Link href='agents' style={{color:'#000',textDecoration:'none'}} >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Agents" />
            </ListItemButton>
          </Link> */}

          
          
        </List>
      </Collapse>
      
      <ListItem button onClick={()=>{goToLocation('change-password')}} >
            <ListItemIcon><LockRoundedIcon /></ListItemIcon>
            <ListItemText primary="Change Password" />
      </ListItem>

      <ListItem button onClick={()=>{logout()}} >
            <ListItemIcon><LogoutIcon /></ListItemIcon>
            <ListItemText primary="Logout" />
      </ListItem>
      
    </div>
  );

  return (
    <div>
          <Button style={{color:'#FFFFFF'}} onClick={toggleDrawer('left', true)}><MenuIcon /></Button>
          <SwipeableDrawer
            anchor='left'
            open={state['left']}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {list('left')}
          </SwipeableDrawer>
    </div>
  );
}
